/// <reference path="../../../node_modules/@types/jquery/index.d.ts" />
/// <reference path="../../../node_modules/@types/bootstrap/index.d.ts" />
/// <reference path="../../../node_modules/@types/jquery.validation/index.d.ts" />

export class Register {

    Initialize(): void {
        $('input[name="Input.Email"]').on('change', () => {
            Register.AllowRegistration();
        });
        $('input[name="Input.Password"]').on('change', () => {
            Register.AllowRegistration();
        });
        $('input[name="Input.ConfirmPassword"]').on('change', () => {
            Register.AllowRegistration();
        });
        $('#AcceptTermsAndConditions').on('click', () => {
            Register.AllowRegistration();
        });

    }

    public static AllowRegistration() {
        if ($("#AcceptTermsAndConditions").is(':checked') && $('input[name="Input.Email"]').val() && $('input[name="Input.Password"]').val() && $('input[name="Input.ConfirmPassword"]').val() && $('#formCreateAccount').valid()) {
            $('.btn-primary').prop('disabled', false);
        }
        else {
            $('.btn-primary').prop('disabled', true);
        }
    }


}

//DOM
((window: any, document: any) => {
    $(() => {
        var register = new Register();
        register.Initialize();
	});
})(window, document);
